
export const angleConfig = {
  /** maximum radius of arc */
  arcRadius: 30, // geometryConfig.thickness * 3,

  /** position of label from circle */
  labelPosition: 20, // geometryConfig.thickness * 2,
};
